import React, { useState } from "react";
import ProfileEditModal from "../modals/ProfileEditModal";
import SettingsUI from "../contents/SettingsUI";

function Settings({ userData }) {
    const [isEditing, setIsEditing] = useState(false);

    return (
        <div className="max-w-3xl mx-auto h-full">
            <SettingsUI onOpen={setIsEditing} userData={userData} />
            {isEditing && <ProfileEditModal closeModal={() => setIsEditing(false)} />}
        </div>
    );
}

export default Settings;